import React, { useState, useEffect } from "react";
import { Card } from "@mui/material";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import { useParams } from "react-router-dom";
import BasicBreadcrumbs from "../../components/GeneralComponents/BreadCrumbs";
import { Icon } from "@iconify/react/dist/iconify.js";
import { _List_Transaction_History } from "../../DAL/Listing/TransactionList";
import moment from "moment";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { formatNumber, show_proper_words } from "../../utils/constant";

const DepositHistory = () => {
  const { setnavbarTitle } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const params = useParams();
  const [userList, setUserList] = useState([]);
  const [data, setDataToSend] = useState({});

  const BreadCrumbsList = [
    {
      title: "Deposit Request",
      navigation: "/wallet-transactions",
      active: false,
    },
    {
      title: `Deposit History`,
      navigation: "",
      status: "Active",
    },
  ];

  const getDepositHistory = async () => {
    setLoading(true);
    const response = await _List_Transaction_History(params.id);
    if (response.code === 200) {
      setUserList(response?.status_history);
      setDataToSend(response?.transaction);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  useEffect(() => {
    setnavbarTitle("Deposit History");
    getDepositHistory();
  }, []);

  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 mb-3">
          <BasicBreadcrumbs items={BreadCrumbsList} />
        </div>
        <div className="col-12">
          <Card
            style={{
              border: "2px solid #bebebe21",
            }}
          >
            <div className="row p-3">
              <div className="col-12">
                <div className="mb-3 d-flex align-items-center svg-color date-color">
                  <Icon icon="uiw:date" />
                  <span className="ms-2">
                    {moment(data.date).format("DD MMM YY hh:mm A")}
                  </span>
                </div>
                <div className="row detail_page_list">
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Name:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {data?.user_info?.first_name +
                      " " +
                      data?.user_info?.last_name}
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Email:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {data?.user_info?.email}
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Total Amount:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    ${formatNumber(data?.total_amount)}
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Amount Sent:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    ${formatNumber(data?.amount)}
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Processor Fee:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    ${formatNumber(data?.processed_fee)}
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Processor Fee Type:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {show_proper_words(data?.processed_fee_type)}
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Deposit Method:
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {show_proper_words(data?.deposit_method)}
                  </div>
                </div>
                {userList.map((history, index) => {
                  return (
                    <div className="col-12 mt-3">
                      <div className="card">
                        <div className="card-body">
                          <div class="circle-image circle-image-chat d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-wrap align-items-center">
                              <h5
                                style={{ fontSize: "18px" }}
                                className="mb-0 ms-2 capitalized"
                              >
                                {history.user_info.first_name +
                                  " " +
                                  history.user_info.last_name}
                              </h5>
                              <div className="ms-2">
                                <StatusChip
                                  status={
                                    history?.status === "succeeded"
                                      ? "Approved"
                                      : history?.status === "failed"
                                      ? "Rejected"
                                      : history?.status === "requires_action"
                                      ? "Needs Changes"
                                      : "Pending"
                                  }
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center svg-color date-color">
                              <Icon icon="uiw:date" />
                              <span className="ms-2">
                                {moment(history?.date).format(
                                  "DD MMM YY hh:mm A"
                                )}
                              </span>
                            </div>
                          </div>
                          <p className="mb-0 text-muted ms-2 ">
                            {history?.message}
                          </p>
                          <hr />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DepositHistory;
